import { useEventBus } from '@vueuse/core'

/**
 * Classe para gerenciamento de eventos de ações vindas do WebSocket

 * @function getBus - Obtém (ou cria) um EventBus para o grupo informado.
 * @function on - Escuta eventos de um grupo específico
 * @function emit - Envia um evento para o grupo informado
 * @function clear - Remove todos os listeners de um grupo
 * @function clearAll - Remove todos os listeners de todos os grupos
 */
class EventActionBus {

  constructor() {
    // Armazena os event buses por grupo
    this.buses = new Map()
  }

  /**
   * Obtém (ou cria) um EventBus para o grupo informado.
   * @param {string} conectionName - Nome do grupo.
   * @return {ReturnType<useEventBus>}
   */
  getBus(conectionName) {
    if (!conectionName) {
      throw new Error('[EventActionBus] É necessário informar um nome de grupo.')
    }

    // Reutiliza o bus se já existir
    if (this.buses.has(conectionName)) {
      return this.buses.get(conectionName)
    }

    // Cria e armazena novo EventBus
    const bus = useEventBus(conectionName)
    this.buses.set(conectionName, bus)
    return bus
  }

  /**
   * Escuta eventos de um grupo específico
   * @param {string} conectionName - Nome do grupo
   * @param {Function} callback - Função chamada quando o evento ocorre
   * @return {Function} Função de "unsubscribe" para parar de escutar
   */
  on(conectionName, callback) {
    console.log(`[EventActionBus] Escutando eventos do grupo: ${conectionName}`);
    const bus = this.getBus(conectionName)
    return bus.on(callback)
  }

  /**
   * Emite um evento em um grupo
   * @param {string} conectionName - Nome do grupo
   * @param {any} payload - Dados a enviar
   */
  emit(conectionName, action, payload) {
    const bus = this.getBus(conectionName)
    bus.emit(action, payload)
  }

  /**
   * Remove todos os listeners de um grupo
   * @param {string} conectionName - Nome do grupo
   */
  clear(conectionName) {
    const bus = this.buses.get(conectionName)
    if (bus) {
      bus.reset()
      this.buses.delete(conectionName)
      console.log(`[EventActionBus] Listeners removidos do grupo: ${conectionName}`)
    }
  }

  /**
   * Remove todos os grupos e listeners
   */
  clearAll() {
    this.buses.forEach((bus, name) => {
      bus.reset()
      console.log(`[EventActionBus] Grupo limpo: ${name}`)
    })
    this.buses.clear()
    console.log('[EventActionBus] Todos os grupos foram limpos.')
  }
}

export const eventActionBus = new EventActionBus()
